<template>
  <div v-if="ifLoad" style="width:100%;height:100%;" >
    <el-form-item v-if="ifLoad" class="Signing_form" :rules="!value.ifHide && (!value.styleSet || value.styleSet.showStyle!=7)?value.elRules:null" :style="value.styleSet.pageFieldStyleSet?value.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet" :label-width="value.styleSet.titleNameHide==2?'0px':''" >
      <!-- 点击加号添加 -->
      <template slot="label" class="titleName" v-if="(value.styleSet.titleNameHide!=2)">
        <span :style="value.styleSet.pageFieldNameStyleSet?value.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{value.fieldCnName + ':'}}</span>
      </template>
      <el-button v-if="value.styleSet.ifDrawingData != 2" @click="openMapDialog" :style="value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" class="defaultStyle">地图设置</el-button>
    </el-form-item>
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" :fullscreen="true" center append-to-body :close-on-click-modal="false" title="地图选择">
      <!-- <kw_gis_draw ref="kw_gis_draw" v-if="gisDrawIfLoad && map" v-model="map" :initSource="initSource" @getDrawDataInfo="getDrawDataInfo"></kw_gis_draw> -->
      <div>
        <template v-for="(drawingTypeOne,drawingTypeIndex) in drawingTypeInfo">
          <el-button v-if="value.styleSet.drawingType == drawingTypeOne.value" :key="'start_dw_button_'+drawingTypeIndex" @click="startDraw(drawingTypeIndex)">{{drawingTypeOne.name+'-开始'}}</el-button>
        </template>
        <!-- <el-button tip="线绘制" icon="polyline" @click="startDraw('LineString')" >线</el-button>
        <el-button tip="面绘制" icon="polygon" @click="startDraw('Polygon')" >面</el-button>
        <el-button tip="圆绘制" icon="circle" @click="startDraw('Circle')" >圆</el-button> -->
        <el-button tip="完成绘制" icon="done" @click="doneDraw()" >完成</el-button>
        <el-button tip="清除图形" icon="clear" @click="clearDraw()" >清除</el-button>
      </div>
      <div class="ol-map" :style="'width:'+useWidth+'px;height:'+ useHeight + 'px;'" ref="olMap">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import Map from 'ol/Map'
import View from 'ol/View'
import { Draw } from 'ol/interaction'
import { Tile as TileLayer } from 'ol/layer'
import {XYZ, OSM} from 'ol/source'
import { fromLonLat } from 'ol/proj'
//全屏 显示鼠标当前位置的经纬度 显示比例尺
import { defaults, FullScreen, MousePosition, ScaleLine } from 'ol/control'
import Feature from 'ol/Feature'
//点
import Point from 'ol/geom/Point'
//圆
import Circle from 'ol/geom/Circle'
//多面形
import Polygon from 'ol/geom/Polygon'
//线
import LineString from 'ol/geom/LineString'

import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Icon,Circle as CircleStyle,Fill} from 'ol/style'
//显示的元素结构
import Overlay from 'ol/Overlay'
import { getArea } from 'ol/sphere';

//绘制组件
import kw_gis_draw from '@/components/form/kw_gis_draw.vue';


import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
import { ODraw } from "@/js/ol/POpenLayers.js";
export default {
  name: 'kw_gis',
  props: {
    //地图图形主键数组
    // value: {
    //   type: Array,
    //   default: function(){return[]}
		// },
    value: {
      type: Object,
       default: function(){
        return {};
      }
    },			
    pageSetInfo:{
      type: Object,
      default: function(){
        return {};
      }
    },			
    dataInfo:{
      type: Object,
      default: function(){
        return {};
      }
    },
    //可绘制的图形个数
    maxNum:{
      type:Number,
      default:1
    },
    //编辑状态  1:编辑  2:查看
    editType:{
      type:Number,
      default:1
    },
    nowCenter:{
      type:Object,
      default: function(){
        return{lng: 116.404, lat: 39.915}
      }
    },

    //圆半径 
    circleRadius:{
      type:Number,
      default:150
    },
    ifRefresh:{
      type:Boolean,
      default:true
    }
  },
  data() {
    let self = this;
    return {
      //图形类型数组
      drawingTypeInfo:[{name:"点",value:1,drawType:"Point"},{name:"海量点",value:2},{name:"折线",value:3,drawType:"LineString"},{name:"多边形",value:4,drawType:"Polygon"},{name:"圆形",value:5,drawType:"Circle"},{name:"标签",value:6}],
      ifLoad:false,
      gisDrawIfLoad:false,
      useWidth:500,
      useHeight:500,
      tk:"b1acdd87b938f6395b3f61d473f140ac",
      map:null,
      mOlDraw:null,
      initSource:null,
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
        ifLoad:false
      },
      //地图图形对应的数据数组
      valueInfo:[],
      mapCenter:[106.26667, 38.46667],
      pointLayerStyle:new Style({
        image: new Icon({
          scale: 0.5, //大小
          src: require('./../look/img/site.png'), //图片
          // color: "#409EFF", //颜色
        }),
      })
    };
  },
  created() {
    var that = this;
    that.useWidth = window.innerWidth;
    that.useHeight = window.innerHeight;
    that.ifLoad = true;
  },
  mounted() {
    
  },
  beforeDestroy(){
    
  },
  destroyed(){

  },
  watch:{
    ifRefresh:function(newVal){
      
    }
  },
  computed:{
  },
  components: {
    kw_gis_draw
  },
  methods: {
    openMapDialog:function(){
      var that = this;
      this.dialogInfo.ifLoad = true;
      this.$nextTick(function(){
        that.initMap();
        that.loadJsonInfoFromDb();
      })
    },
    closeMapDialog:function(){
      this.dialogInfo.ifLoad = false;
    },
    initMap:function(){
      var that = this;
      console.log("that.$refs.olMap=================",that.$refs.olMap);
      // 使用高德
      const tileLayer = new TileLayer({
          source: new XYZ({
            // url:"http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk="+that.tk
            // url:"http://t4.tianditu.com/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=" +that.tk
              // url: 'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
            url:"http://t0.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=" + that.tk
          })
      })
      const bzLayer = new TileLayer({
          name:'注记',
          source: new XYZ({
            crossOrigin:'anonymous',
            url:'http://t0.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=' + that.tk
          })
        })
      let map = new Map({
          layers: [tileLayer,bzLayer],
          view: new View({
              center: fromLonLat([106.26667, 38.46667]),//地图中心点
              zoom: 15,// 缩放级别
              minZoom: 0,// 最小缩放级别
              maxZoom: 18,// 最大缩放级别
              constrainResolution: true// 因为存在非整数的缩放级别，所以设置该参数为true来让每次缩放结束后自动缩放到距离最近的一个整数级别，这个必须要设置，当缩放在非整数级别时地图会糊
          }),
          target: that.$refs.olMap,// DOM容器
          controls: defaults().extend([
              new FullScreen(), // 全屏
              // new MousePosition(), // 显示鼠标当前位置的经纬度
              // new ScaleLine()// 显示比例尺
          ])
      })

      // var geocoder = new Geocoder('nominatim', {
      //   // provider: 'mapquest',
      //   // key: '__some_key__',
      //   lang: 'en-US', //en-US, fr-FR
      //   placeholder: 'Search for ...',
      //   targetType: 'text-input',
      //   limit: 5,
      //   keepOpen: true
      // });
      // map.addControl(geocoder);
      that.map = map;
      console.log("map===================================",map);
      // map.on('click', e => {
      //     const coordinate = e.coordinate // 获取坐标
      //     console.log("coordinate================",coordinate);
      //     that.addPoint(coordinate);
      // })
    
 
      // that.addMarket();
     
    },
    /**从后台数据库中加载数据 */
    loadJsonInfoFromDb:function(){
      var that = this;
      if(that.value.defaultCheckValue) {
        var toHtData = {};
        toHtData.tableInfo = '{"MAP_DRAWING":[{"MAP_DRAWING_POINT":[]}]}';
        toHtData.mainId = that.value.defaultCheckValue;
        var loading = that.$loading({
            lock: true,
            text: '加载数据中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        var url = "wxXcxSet_getJsonInfoFromDb.do";
        //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
        utils.request(that,{
            url: url, //仅为示例，并非真实的接口地址
            data: toHtData,
            success: function (res) {
                loading.close();
                console.log("res.data=======================",res.data);
                var loadHtJson = res.data;
                var MAP_DRAWING = loadHtJson.MAP_DRAWING;
                var valueInfo = [];
                var mapCenter = [];
                MAP_DRAWING.forEach(valueOne => {
                  var path = [];
                  var arrayPath = [];
                  if(valueOne.MAP_DRAWING_POINT) {
                    valueOne.MAP_DRAWING_POINT.forEach(one => {
                      path.push({
                        "lng":one.LONGITUDE,
                        "lat":one.LATITUDE
                      })
                      arrayPath.push([
                        one.LONGITUDE,
                        one.LATITUDE
                      ])
                    });
                  }
                  valueInfo.push({
                    "MD_NAME" : valueOne.MD_NAME,
                    "ZD_DRAWING_TYPE" : valueOne.ZD_DRAWING_TYPE,
                    "MD_RADIUS" : valueOne.MD_RADIUS,
                    "MAP_CENTER_LNG":valueOne.MAP_CENTER_LNG,
                    "MAP_CENTER_LAT":valueOne.MAP_CENTER_LAT,
                    "path":path,
                    "arrayPath":arrayPath,
                  });

                  if(valueOne.MAP_CENTER_LNG > 0) {
                    mapCenter[0] = valueOne.MAP_CENTER_LNG
                    mapCenter[1] = valueOne.MAP_CENTER_LAT
                  }
                  
                })
                that.mapCenter = mapCenter;
                that.valueInfo = valueInfo;
                that.setMapCenter();
                that.initMapDrawData();
                that.gisDrawIfLoad = true;
                that.initODraw();
            },
            error:function(){
                loading.close();
                // 保存失败
                that.$message({
                    message: "服务器出现问题,请重试或者联系管理员",
                    type: 'error'
                });
            }
        })
      } else {
        that.gisDrawIfLoad = true;
        that.initODraw();
      }
    },
    setMapCenter:function(){
      var view = this.map.getView();
      console.log("this.mapCenter=====================",this.mapCenter);
      view.setCenter(this.mapCenter);
    },
    /**
     * 初始化绘制地图信息
     */
    initMapDrawData:function(){
      var that = this;
      if(that.valueInfo && that.valueInfo.length > 0) {
        var initSource = new VectorSource();
        var featuresArr = [];
        that.valueInfo.forEach(valueOne => {
          var featureOne = new Feature();
          console.log("valueOne.arrayPath============================",valueOne.arrayPath);
          if(valueOne.ZD_DRAWING_TYPE == 1) {
            //点
            var pointOne = new Point(valueOne.arrayPath[0]);
            console.log("getCoordinates============================",pointOne.getCoordinates());
            featureOne.setGeometry(pointOne);
            featureOne.setStyle(that.pointLayerStyle);
            
          } else if(valueOne.ZD_DRAWING_TYPE == 4) {
            //多边形
            // var coordinateArr = 
            
            var polygonOne = new Polygon([],null,null);
            polygonOne.setCoordinates([valueOne.arrayPath]);
            console.log("getCoordinates============================",polygonOne.getCoordinates());
            featureOne.setGeometry(polygonOne);
          }
          featuresArr.push(featureOne);
        });
        initSource.addFeatures(featuresArr);
        that.initSource = initSource;
        // that.map.addLayer(new VectorLayer({
        //   title: "草图图层", // ol-ext图层控件属性
        //         noSwitcherDelete: true, // ol-ext图层控件属性
        //     source: initSource, 
        // }));

      }
    },
    /**
     * 绘制完成后获取到绘制后的数据
     */
    getDrawDataInfo:function(mOlDraw){
      var that = this;
      console.log("mSource====================================",mOlDraw.mSource);
      var valueInfo = [];
      if(mOlDraw.mSource) {
        var featuresArr = mOlDraw.mSource.getFeatures();
        console.log("featuresArr=================================",featuresArr);
        featuresArr.forEach((featureOne,featureIndex) => {
          var geometry = featureOne.getGeometry();
          console.log("geometry====================================",geometry);
          var valueOne = null;
          if(geometry instanceof Circle) {
            var centerArr = geometry.getCenter();
            var radius = geometry.getRadius();
            valueOne = {MD_NAME:'圆_'+featureIndex,ZD_DRAWING_TYPE:5,MD_RADIUS:radius,path:[{lng: centerArr[0], lat: centerArr[1]}],arrayPath:[centerArr]};
          } else if(geometry instanceof Point){
            var pointArr = geometry.getCoordinates();
            valueOne = {MD_NAME:'点_'+featureIndex,ZD_DRAWING_TYPE:1,path:[{lng: pointArr[0], lat: pointArr[1]}],arrayPath:[pointArr]};
          } else {
            var ZD_DRAWING_TYPE = 0;
            var area = 0;
            if(geometry instanceof Polygon) {
              ZD_DRAWING_TYPE = 4;
              area = getArea(geometry,{
                    projection:'EPSG:900913'
              });
              console.log("area=======================",area);

            } else if(geometry instanceof LineString) {
              ZD_DRAWING_TYPE = 3;
            }
            var pointArr = geometry.getCoordinates();
            console.log("pointArr=========================",pointArr);
            pointArr = pointArr[0];
            var path = [];
            pointArr.forEach((pointOne,pointIndex) => {
              console.log("pointOne=====================",pointOne);
              path.push({lng: pointOne[0], lat: pointOne[1]})
            })
            valueOne = {MD_NAME:'线_'+featureIndex,ZD_DRAWING_TYPE:ZD_DRAWING_TYPE,MD_AREA:area,path:path,arrayPath:pointArr};
          }
          valueInfo.push(valueOne);
        });
        that.valueInfo = valueInfo;
        console.log("valueInfo====================================",valueInfo);
        that.saveJsonInfoToDb();
      }
    },
    /**保存数据到后台 */
    saveJsonInfoToDb:function(){
      var that = this;
      if(that.valueInfo && that.valueInfo.length > 0) {
        pageUtils.saveMapDrawingInfo(that);
      }
    },
    initODraw(){
      var that = this;
      console.log("initODraw==============================", this.initSource);
      // that.map.addLayer(new VectorLayer({
      //     title: "草图图层", // ol-ext图层控件属性
      //           noSwitcherDelete: true, // ol-ext图层控件属性
      //       source: that.initSource, 
      //   }));
      if(that.value.styleSet.drawingType==1) {
        this.mOlDraw = new ODraw(this.map,this.initSource,that.pointLayerStyle);
      } else {
        this.mOlDraw = new ODraw(this.map,this.initSource,null);
      }
      this.mOlDraw.init();
    },
    startDraw(drawingTypeIndex) {
      this.mOlDraw.startDraw(this.drawingTypeInfo[drawingTypeIndex].drawType);
    },
    doneDraw() {
      this.mOlDraw.doneDraw();
      // .getGeometry().getCoordinates()  JSON.stringify(this.mOlDraw.mSource.getFeatures()
      this.getDrawDataInfo(this.mOlDraw);
    },
    clearDraw() {
      this.mOlDraw.clearDraw();
      
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.noSelectedDrawType{
  box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
   background: rgb(255, 255, 255);
   color: #000
}
.selectedDrawType{
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    cursor: pointer;
    text-size-adjust: none;
    background: rgb(142, 168, 224);
    box-shadow: rgba(0, 0, 0, 0.35) 2px 2px 3px;  
    color: #fff  
}
.tabDrawType{
    border-width: 1px;
    border-style: solid;
    border-color: rgb(139, 164, 220);   
    padding: 10px 10px;
    font: bold 12px / 1.3em arial, sans-serif;
    text-align: center;
    white-space: nowrap;
    border-radius: 0px 3px 3px 0px;
}
.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}
</style>
